export default __webpack_public_path__ + "static/media/mastercard.e2327d22.svg";